export const apiVersion =
  process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-01-08';

// export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET || "production";
const rawDataset = process.env.NEXT_PUBLIC_SANITY_DATASET || 'production';
export const dataset = rawDataset.replace(/^["'""']+|["'""']+$/g, '').trim();

export const token =
  process.env.SANITY_API_READ_TOKEN ||
  process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN ||
  '';

if (!token) {
  throw new Error(
    'A secret is provided but there is no `NEXT_PUBLIC_SANITY_API_READ_TOKEN` environment variable setup. ' +
      process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN,
  );
}

const rawProjectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || 'yt1ed4l0';
// Validate and clean projectId (remove quotes, whitespace, and smart quotes)
export const projectId = rawProjectId
  .replace(/^["'""']+|["'""']+$/g, '') // Remove surrounding quotes (regular, smart, single)
  .trim(); // Remove whitespace

export const useCdn = true;

function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}

export const STUDIO_ORIGIN =
  process.env.NODE_ENV !== 'production'
    ? process.env.NEXT_PUBLIC_STUDIO_ORIGIN || '/studio'
    : process.env.NEXT_PUBLIC_STUDIO_ORIGIN || '/studio';

export const domain = assertValue(
  process.env.NEXT_PUBLIC_DOMAIN,
  'Missing environment variable: NEXT_PUBLIC_DOMAIN',
);

function normalizeDomain(domain: string): string {
  // Remove protocol if present
  const cleanDomain = domain.replace(/^https?:\/\//, '').replace(/\/$/, '');

  // Map actual domains to schema values
  if (cleanDomain === 'placeholder' || cleanDomain === 'www.placeholder') {
    return 'main';
  }
  if (cleanDomain === 'get.placeholder') {
    return 'lp';
  }

  // Default fallback for localhost and other development domains
  return 'main';
}

export const normalizedDomain = normalizeDomain(domain);
